import { FlowStepEditor } from "../FlowStepEditor";
import { SequenceEndStep } from "../../../rule-engine-core/Flow/Steps/General/SequenceEndStep";
import styled from "styled-components";
import React from "react";

const SequenceEndStepDiv = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
`;

const SequenceEndStepConnector = styled.div`
    position: absolute;
    opacity: 0;
    top: calc(100% + 20px);
    left: 50%;
    transform: translateX(-50%);
`;

export class SequenceEndStepEditor extends FlowStepEditor<SequenceEndStep> {
    renderEditUI(): JSX.Element | null {
        return <></>;
    }

    render() {
        return (
            <SequenceEndStepDiv>
                <SequenceEndStepConnector id={this._id} />
            </SequenceEndStepDiv>
        );
    }
}
